import { Building2, Users, Heart, PartyPopper, Home as HomeIcon, UsersRound } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { PageHero, SectionHeading, FeatureGrid, CTABand } from "@/components/PageBlocks";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TYPES = [
  { icon: Users, title: "Adults-Only Escapes", desc: "Quieter, grown-up resorts built for relaxing." },
  { icon: UsersRound, title: "Family-Friendly Resorts", desc: "Room for everyone, with activities for all ages." },
  { icon: Heart, title: "Couples Getaways", desc: "Romantic settings for two." },
  { icon: Users, title: "Group Resorts", desc: "Space and options that work for a whole group." },
  { icon: PartyPopper, title: "Celebrations", desc: "A backdrop for birthdays, anniversaries, and reunions." },
  { icon: Heart, title: "Destination Weddings", desc: "Say 'I do' somewhere unforgettable." },
  { icon: HomeIcon, title: "Villas & Private Escapes", desc: "Private homes with space and privacy for your group." },
  { icon: Building2, title: "Finding the Right Fit", desc: "We weigh travel style, budget, group needs, destination, and priorities to recommend the right place." },
];

export default function Resorts() {
  useSeo({ title: "All-Inclusive, Without the Guesswork | Inforno Travel", description: "Resorts can look alike online but feel very different. Inforno Travel helps you narrow the choices to the resort or villa that fits your trip." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <PageHero overline="Resorts & Escapes" title="All-Inclusive, Without the Guesswork." image={IMAGES.resort}
        sub="Resorts can look similar online but differ a lot in atmosphere, dining, location, activities, room options, and who they're best for. We help you narrow the choices to the one that fits."
        primary={{ label: "Find Your Next Escape", to: "/start-your-journey" }} />

      <section className="py-24 md:py-32 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="Ways to Escape" title="A place for every kind of trip" /></div>
          <FeatureGrid items={TYPES} />
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] border-y border-white/10">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7"><SectionHeading overline="Finding the Right Fit" title="The right resort is the one that fits you" /></div>
          <div className="md:col-span-4 md:col-start-9">
            <Reveal delay={0.1}>
              <p className="font-body text-white/60 text-sm md:text-base leading-relaxed font-light">
                Your travel style, budget, group needs, destination, and priorities all shape the recommendation.
                Tell us what matters most, and we'll point you toward resorts and escapes that match.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand eyebrow="Let's find your fit" title="Where would you like to unwind?" label="Find Your Next Escape" to="/start-your-journey" showRtb />
      <Footer />
    </div>
  );
}
